"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
exports.FractionOfSecondParser = void 0;
var _Parser = require("../Parser.js");
var _utils = require("../utils.js");
class FractionOfSecondParser extends _Parser.Parser {
  constructor() {
    super(...arguments);
    __publicField(this, "priority", 30);
    __publicField(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token) {
    const valueCallback = (value) => Math.trunc(value * Math.pow(10, -token.length + 3));
    return (0, _utils.mapValue)(
      (0, _utils.parseNDigits)(token.length, dateString),
      valueCallback
    );
  }
  set(date, _flags, value) {
    date.setMilliseconds(value);
    return date;
  }
}
exports.FractionOfSecondParser = FractionOfSecondParser;
